import { render, staticRenderFns } from "./NodeButtonWa.vue?vue&type=template&id=0afe640f&scoped=true&"
import script from "./NodeButtonWa.vue?vue&type=script&lang=js&"
export * from "./NodeButtonWa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afe640f",
  null
  
)

export default component.exports